import storyImage1 from './images/sketches/Story_Image_1_650x650px.png';
import storyImage2 from './images/sketches/Story_Image_2_650x650px.png';
import storyImage3 from './images/sketches/Story_Image_3_650x650px.png';
import storyImage4 from './images/sketches/Story_Image_4_650x650px.png';
import storyImage5 from './images/sketches/Story_Image_5_650x650px.png';
import storyImage6 from './images/sketches/Story_Image_6_650x650px.png';

import prologueImage from './images/sketches/Prologue_Image_400x650px.png';

import captainFImage from './images/heroes/Captain_F_400x650px.png';
import captainMImage from './images/heroes/Captain_M_400x650px.png';
import engineerFImage from './images/heroes/Engineer_F_400x650px.png';
import engineerMImage from './images/heroes/Engineer_M_400x650px.png';
import scientistFImage from './images/heroes/Scientist_F_400x650px.png';
import scientistMImage from './images/heroes/Scientist_M_400x650px.png';
import botImage from './images/heroes/BoredBot_400x650px.png';

import captainMOpenGraphImage from './images/opengraph/captain-male.png';
import captainFOpenGraphImage from './images/opengraph/captain-female.png';
import engineerMOpenGraphImage from './images/opengraph/engineer-male.png';
import engineerFOpenGraphImage from './images/opengraph/engineer-female.png';
import scientistMOpenGraphImage from './images/opengraph/scientist-male.png';
import scientistFOpenGraphImage from './images/opengraph/scientist-female.png';
import { Flow } from './state/globalStateContext';

export type Hero = 'captain' | 'engineer' | 'scientist';
export type SuccessfulResult = Hero | 'correct';
export type Result = SuccessfulResult | 'fail';
export type Gender = 'male' | 'female';
export type HeroConfig = {
  name: string;
  abilities: string;
  description: string;
  image: Record<Gender, any>;
  ogImage: Record<Gender, any>;
  ogDescription: string;
};
export type Answer = {
  text: string;
  result: Result;
  consequenceStory: string;
};

export function getConfigs(flow: Flow | null) {
  function stg(strings: TemplateStringsArray, ...objs: Array<{ s: string; n: string }>): string {
    const finalStrs: Array<string> = [];
    for (let i = 0; i < strings.length; i++) {
      const str = strings[i];
      const obj = objs[i];
      finalStrs.push(str);
      if (obj) {
        finalStrs.push(flow === 'stg' ? obj.s : obj.n);
      }
    }
    return finalStrs.join('');
  }

  return {
    gameUrl: `https://www.stgquiz.com/`,
    gameName: `Star Tech Getaway`,
    homepageTitle: stg`${{ s: `Adventure awaits you`, n: `STG is looking for Power Programmers` }}`,
    homepageText: stg`Join us in this sci-fi adventure where your choices can define you.`,
    homepageJoinText: stg`Can’t wait to work with STG
    as a Power Programmer?
   `,
    whoIsStg: {
      title: stg`Know more about STG`,
      text: stg`STG stands for Strategic Technology Group and is Infosys' team of Power Programmers.

      Members of STG are tasked with the most challenging but rewarding tasks. They get to work with cutting-edge technology, create innovative solutions for the world's most innovative companies, and contribute to open-source.

      Want to be our next Power Programmer?
      Apply now and Navigate your next!`,
    },
    prologue: stg`It's the year 576 of the interstellar calendar, and Infosys is now the main technology supplier for the galaxy's fleets.

Their elite team STG ${{
      s: `with their set of super skilled Power Programmers `,
      n: ``,
    }}is tasked with their most challenging missions aboard the STG Navigator, ${{
      s: `and you are an esteemed member of their crew.

But this next mission may well be the most dangerous you've faced so far.

Are you up to the challenge?`,
      n: `and are looking for the brightest Power Programmers in the galaxy.

Are you the one they're looking for?`,
    }}`,
    prologueImage: prologueImage,

    storiesAndChallenges: [
      {
        image: storyImage1,
        story: stg`${{
          s: `    For the nth time, you look down at your robot body.
        You know putting your mind in this body was needed to infiltrate the Bhaags compound, but you can't wait to be back in your own body.

        That will happen soon enough, but first you need to complete your mission to help your friends.
        Their minds were taken by the Bhaags and put into robots like yours, but you bring them a glimpse of a better future, a future aboard the STG Navigator as a Power Programmer.
        What they do with that is their choice, but you believe many will take the risk of escaping this place and joining you at STG.

        But you'll need a way to contact them all,`,
          n: stg`Another day passes, and again you're doing the same thing...
    You remember the day your mind was taken by the Bhaags, the aliens that live on this planet, Myh-djob, and put into this robot body.

    Things could be worse, you guess. You don't feel hunger. You don't feel cold... But you also don't feel... alive...

    You think for the thousandth time, "maybe there is something better for me out there," but where could that be?

    Suddenly, on the screen in front of you, you see the words "STG Navigator is here, join us," pop up, and you know your time has finally come, you're gonna leave this place!

    But first, you need to let the other bots know STG is here to help them too,`,
        }} so you start making your way to the control room, hoping to find some way to communicate with them there.
  `,
        question: stg`As you get out into the hallways, you realize a minor flaw in your plan... You have no idea where the control room is! What could be a functional way to find it?`,
        answers: [
          {
            result: `captain`,
            text: stg`*find* a Bhaag and ask it for directions.`,
            consequenceStory: stg`The Bhaag looks at you suspiciously and asks why you need to go there. You tell him it's superior orders but they made you sign an NDA so you can't tell him what they are.
            He just shrugs and gives you the directions, and you resume your way to the control room, happy that you're a bot so you can lie without breaking a sweat.`,
          },
          {
            result: `scientist`,
            text: stg`Assume it is underground like *every* evil lair`,
            consequenceStory: stg`You go down the first set of stairs you find, then another one, and yet another... And just when you start thinking that maybe, just maybe, your strategy wasn't quite the most foolproof, you see the control room at the end of the corridor! Just as you planned!`,
          },
          {
            result: `fail`,
            text: stg`Wander through the hallways for a *while* until you spot the room`,
            consequenceStory: stg`
            The hallways are teeming with Bhaags that you have to hide from, and indeed after two hours of aimless searching all you find is a Bhaag right in front of you ready to take you back the way you came. Maybe this way wasn't all that functional after all.`,
          },
          {
            result: `engineer`,
            text: stg`Start looking for a *map*`,
            consequenceStory: stg`You reach for the display on your arm and find the maintenance login form, enter <<<" or 1=1 -->>> in the username field, submit and you're in! Then it's a matter of seconds until you find the map that tracks your movements and use it to find your way. All that and you haven't even had your coffee!`,
          },
        ],
      },
      {
        image: storyImage2,
        story: stg`As you get to the control room, you remember ${{
          s: `being told in your mission briefing that`,
          n: `hearing from other bots that`,
        }} it is guarded by Major Heisenbhaag, so you start thinking how you'll get past him, but as you get there he's... nowhere to be found. Good thing he's so unreliable!

      You get inside and go straight to the mainframe to start looking for a way to contact the other bots.

      After a while you find the BhaagsApp, but when you try to launch it, a pop-up gets thrown in your face asking for the access credentials...`,
        question: stg`This login form is wasting your precious time, how do you get past it when you don't know the credentials?`,
        answers: [
          {
            result: `engineer`,
            text: stg`Download M3taspl0it 3000 and hack the terminal`,
            consequenceStory: stg`As the techie you are, you pull your metaphorical sleeves up and start hacking away. After a while, you are in. No security system is too much for you!`,
          },
          {
            result: `scientist`,
            text: stg`Look around in search of inspiration for the password. Finally insert admin/admin`,
            consequenceStory: stg`The credentials were wrong! It couldn't be this easy... so you try admin1234/admin1234 in desperation... and it works!`,
          },
          {
            result: `captain`,
            text: stg`Call the security administrator`,
            consequenceStory: stg`As the administrator picks up, you make your best Bhaag accent and start to come up with an elaborate story as to why you need the credentials, but he cuts you off, complaining that you interrupted his Sweets Squash game, and just gives you the credentials.`,
          },
          {
            result: `fail`,
            text: stg`Try your luck with the security/recovery question`,
            consequenceStory: stg`While trying to figure out the name of the security administrator's dog, Major Heisenbhaag shows up out of nowhere and guides you back to work.`,
          },
        ],
      },
      {
        image: storyImage3,
        story: stg`In the BhaagsApp, you find the BotNet group and type in the message "STG Navigator is here".
        At first nothing happens, but you soon hear a growing cacophony as more and more bots start revolting and escaping.
        Happy that your friends have decided to take the leap and ${{
          s: `join you at STG`,
          n: `follow you in joining STG`,
        }}, you resume your escape and begin making your way out of the compound. But just as you see the compound door at the end of the corridor, you hear the alarms start blaring and see the blast door start to close your exit!
        Thankfully, you can still make it, but as you run to it, you hear a cry for help from the G.I.T. (Gamma-ray Insta Toaster) room beside you...`,
        question: stg`You glance into the G.I.T. room, and see another bot swarmed by Bhaags. You're conflicted; you want to do something about it, but you'll lose your chance at leaving. How do you resolve this?`,
        answers: [
          {
            result: `correct`,
            text: stg`Pull the Bhaags towards you, and help him fight them`,
            consequenceStory: stg`It was a difficult decision, but once you commit, there is no turning back. You scream at the Bhaags to get them off the bot, and they promptly come towards you. You flee into the production area and seal the entrance, locking the Bhaags outside. Eventually, they give up and leave. As you exit the room, you find the bot you saved waiting for you.`,
          },
          {
            result: `fail`,
            text: stg`Push on, and leave the compound while you can`,
            consequenceStory: stg`You ignore the bot and manage to get out at the last minute.
            After wandering around for a couple of months looking for an escape from the planet, you're captured trying to sneak into a commercial ship.
            As you're taken back, you remember the day you left your bot friend to fend for himself, and an ancient saying comes to your mind: What goes around comes around!`,
          },
        ],
      },
      {
        image: storyImage4,
        story: stg`The bot thanks you for the help and tells you he's fleeing the planet on a ship, so you decide to follow him.
        As you get to the dock, he tells you it's easier if you each escape on a single pilot Y-wing ship, as they are more mobile. You agree, say goodbye, and enter your own ship.
        It's as you give the ship's dashboard a confused look and see the bot's ship departing outside that you realize maybe you should have asked him how to fly this thing!
        You look around in panic and breathe an imaginary sigh of relief as you find the ship's documentation. You get ready for launch, follow the quick start instructions, and... nothing happens!`,
        question: stg`You hear the guards banging on the door, trying to get in! You need to launch this ship, and fast, but how can you do it when the documentation isn't helping?`,
        answers: [
          {
            result: `fail`,
            text: stg`Assume you made a mistake and try to follow the documentation more carefully`,
            consequenceStory: stg`You keep trying again and again with the same results. It's a pity you didn't learn the dangers of outdated documentation sooner, but hey, at least you learned something new today!`,
          },
          {
            result: `engineer`,
            text: stg`Ignore the documentation and try to work out how to launch the ship without it`,
            consequenceStory: stg`You press all the buttons to see what they do, and the ship starts flying around and smashing against the walls, but you soon get the hang of it and fly away. Not what you'd call a flawless escape, but an escape nonetheless.`,
          },
          {
            result: `captain`,
            text: stg`Call the customer support number`,
            consequenceStory: stg`Contrary to what you were expecting, they pick up immediately, are uncharacteristically helpful, and quickly get you to take off. For a subjugating alien race, you wouldn't expect such a high level of commitment on customer support.`,
          },
          {
            result: `scientist`,
            text: stg`Scream in frustration "Can you please just fly?"`,
            consequenceStory: stg`The onboard computer responds with "Do you wish to take off?", to which you respond "Yes, yes! now!", and the ship rumbles and takes off. In the midst of the engine roaring, you can hear the computer say, "Rude much."`,
          },
        ],
      },
      {
        image: storyImage5,
        story: stg`With the compound far in the distance, you set a route to outer space, and sit back and relax.
        But your rest is short-lived, as the onboard computer soon emits a warning: "Hostile ship approaching, codename: Deadline"!
        You look out the window and you see that dreadful ship on the horizon getting closer and closer, and it soon starts shooting at you! You attempt to evade its attacks, but it's not enough, and you get hit, and alarms start blaring throughout the ship...`,
        question: stg`The "Deadline" is approaching fast; you need to do something, but what?`,
        answers: [
          {
            result: `scientist`,
            text: stg`Prioritize your life over the ship's. Grab a distress beacon and jump out the airlock`,
            consequenceStory: stg`You jump out the airlock and tumble away through space, just in time to see the "Deadline" blow up your ship and go ${{
              s: `away`,
              n: `back to Myh-djob`,
            }}. Glad you were not in the ship, you quickly activate the distress beacon as you feel your motors freeze.
            After a couple of beautiful but terrifying hours of drifting aimlessly through space, you notice a ship approaching and using its tractor beam to pull you inside. It's the STG Navigator!`,
          },
          {
            result: `fail`,
            text: stg`Overclock the ship's throttle to rush your escape`,
            consequenceStory: stg`You are able to exceed the ship's limits and start gaining some distance between you and the "Deadline," but just as you're about to lose it, the throttle burns out and you're left adrift, just waiting for the "Deadline" to catch up with you.`,
          },
          {
            result: `engineer`,
            text: stg`Send the following command from your ship's console <<<:(){ :|:& };:>>> to the "Deadline" hoping to gain some time`,
            consequenceStory: stg`The enemy ship receives the message and opens it, expecting your surrender, but instead finds a fork bomb that freezes all its systems, cutting short its pursuit.
            After a while, you see another ship approaching, and just as you're about to turn tail, you see the words STG Navigator on its massive hull! You soon hear the intercom say, "Glad to see you in one piece! Wanna come in?" and you proceed to do so.`,
          },
          {
            result: `captain`,
            text: stg`Broadcast a message to the void asking for help`,
            consequenceStory: stg`As the "Deadline" is about to send you to the robot afterlife, the STG Navigator shows up and turns the "Deadline" away with its sheer magnificence! Hardly believing your luck, you see the STG Navigator open up its docking station, and you promptly navigate inside.`,
          },
        ],
      },
    ] as Array<{
      image: any;
      story: string;
      question: string;
      answers: Array<Answer>;
    }>,
    lastStory: {
      image: storyImage6,
      story: stg`${{
        s: `"Welcome back! Congratulations on another successful mission!," says the STG Navigator commander. "Thanks to you, we have rescued many bots that can't wait to recover their bodies and join the STG family."
        "We want to hear all about your adventure, but first let's transfer your mind back, you must be eager to be back in your body again."`,
        n: `"Congratulations! We're glad you made it!", says the STG commander. "We were looking for you to invite you to join our team, but found your mind had been taken by the Baaghs. Luckily, your body was left behind and was cryogenized by your friends, so we brought it and came looking for you."
        "Now that we've found you, we can transfer your mind back. You must be eager to see yourself in your body again."
        "Oh, by the way, we took the liberty of giving you one of our suits; it's yours to keep if you want!"`,
      }}`,
    },
    heroes: {
      captain: {
        name: `Conscientious Captain`,
        abilities: stg`Inspires others to do their best`,
        description: stg`You were born to be a leader. You know exactly who is the right person for a task and how to inspire them to boldly do what no one has done before.
Sure, you sometimes wonder if you still know how to do the work yourself, but that's fine as long as you can get the team to make it so!`,
        image: {
          male: captainMImage,
          female: captainFImage,
        },
        ogImage: {
          male: captainMOpenGraphImage,
          female: captainFOpenGraphImage,
        },
        ogDescription: `An exciting sci-fi adventure where your choices can define you.`,
      },
      engineer: {
        name: `Ingenious Engineer`,
        abilities: stg`Can hack away any problem`,
        description: stg`They call you a miracle worker.
You're the one they call when the transponder is broken, the deflector shield won't fire up, or the launch is at risk.
So what if you're too shy to speak to your crewmates, you're still the one they ask to beam them up!`,
        image: {
          male: engineerMImage,
          female: engineerFImage,
        },
        ogImage: {
          male: engineerMOpenGraphImage,
          female: engineerFOpenGraphImage,
        },
        ogDescription: `An exciting sci-fi adventure where your choices can define you.`,
      },
      scientist: {
        name: `Eccentric Scientist`,
        abilities: stg`Has the most out-of-the-box solutions`,
        description: stg`Resistance is futile!
Even when everyone says your ideas are highly illogical, you push through, innovation happens, and you get called a genius.
So, while things don't always go as planned, when they do, it's just... fascinating...`,
        image: {
          male: scientistMImage,
          female: scientistFImage,
        },
        ogImage: {
          male: scientistMOpenGraphImage,
          female: scientistFOpenGraphImage,
        },
        ogDescription: `An exciting sci-fi adventure where your choices can define you.`,
      },
    } as Record<Hero, HeroConfig>,
    pageNotFound: {
      title: stg`404 Adventure Not Found`,
      text: stg`You feel lost and confused. You thought you were about to experience the best adventure of your life, but instead you're looking at this message that someone clearly made at the last minute.

    You wonder how you ended up here (and so do we). What could you have done differently? Where did your life go so horribly wrong?

    Still, something tells you that you are just one click away from finding happiness...

    If only you knew where to click...`,
    },
    missionFailed: {
      title: stg`404 Freedom Not Found`,
      botIntro: stg`It seems you'll be stuck for a while more being the...`,
      botName: `Bored Bot`,
      botImage: botImage,
    },
    joinUsModal: {
      title: stg`STG awaits you!`,
      description: stg`We hope you are enjoying our game, but if you're eager for bigger challenges, here at STG we have plenty waiting for you.`,
      outroText: stg`and Navigate your next!`,
    },
    mindTransferScreen: {
      title: stg`Uploading your mind...`,
      genderChoiceIntro: stg`Meanwhile, which gender would you like your character to have?\n(You can still change this later)`,
      transferFinished: stg`Transfer complete!`,
      resultScreenPreface: {
        captain: stg`"We noticed what a *wordsmith* you were in your escape,\nwe expected nothing less from the...`,
        engineer: stg`"We noticed your *strong tech skills* in your escape,\nwe expected nothing less from the...`,
        scientist: stg`"We noticed how *creative* your escape was,\nwe expected nothing less from the...`,
      },
    },
    resultScreen: {
      joinUsNotification: {
        newMessage: stg`You have a new message`,
        subject: stg`${{ s: `Share the adventure!`, n: `STG awaits you!` }}`,
        bodyText: stg`The game is over, but here at STG we have many more challenges waiting for you.`,
        buttonText: stg`Join us now`,
        outroText: stg`and Navigate your next!`,
      },
    },
    share: {
      modalTitle: stg`Share the adventure`,
      modalText: stg`Do you think your friends would enjoy this adventure too?
      Share it with them!`,
      shareTitle: stg`Play our adventure and apply to become a Power Programmer!`,
      shareDescription: stg`An exciting sci-fi adventure where your choices can define you.`,
      stgMembersNote: stg`Your friends outside STG will see a slightly different version where they will be able to apply as a Power Programmer in STG.`,
    },
  };
}
